import * as g from "@made-people/imgproxy";
var y = function() {
  var e = this, r = e.$createElement, i = e._self._c || r;
  return i("img", {
    attrs: {
      src: e.imgproxySrc(e.src, {
        width: e.width,
        background: e.background
      }),
      srcset: e.srcSet,
      alt: e.alt,
      loading: e.loading
    },
    on: {
      load: e.imageLoaded
    }
  });
}, v = [];
function S(e, r, i, s, n, l, u, d) {
  var t = typeof e == "function" ? e.options : e;
  r && (t.render = r, t.staticRenderFns = i, t._compiled = !0), s && (t.functional = !0), l && (t._scopeId = "data-v-" + l);
  var o;
  if (u ? (o = function(a) {
    a = a || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !a && typeof __VUE_SSR_CONTEXT__ < "u" && (a = __VUE_SSR_CONTEXT__), n && n.call(this, a), a && a._registeredComponents && a._registeredComponents.add(u);
  }, t._ssrRegister = o) : n && (o = d ? function() {
    n.call(
      this,
      (t.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : n), o)
    if (t.functional) {
      t._injectStyles = o;
      var m = t.render;
      t.render = function(h, c) {
        return o.call(c), m(h, c);
      };
    } else {
      var f = t.beforeCreate;
      t.beforeCreate = f ? [].concat(f, o) : [o];
    }
  return {
    exports: e,
    options: t
  };
}
const p = 1920, $ = 75, b = {
  name: "Vue2Image",
  props: {
    src: {
      type: String,
      required: !0
    },
    format: {
      type: String,
      default: "jpeg"
    },
    quality: {
      type: Number,
      default: null
    },
    alt: {
      type: String,
      required: !0
    },
    width: {
      type: Number,
      default: p
    },
    background: {
      type: String,
      default: null
    },
    widths: {
      type: Array,
      default: () => [320, 640, 1280, p]
    },
    loading: {
      type: String,
      default: "lazy"
    },
    preload: {
      type: Boolean,
      default: !1
    }
  },
  head() {
    if (!!this.preload)
      return {
        link: [
          {
            rel: "preload",
            href: this.imgproxySrc(this.src, {
              width: this.width
            }),
            as: "image"
          }
        ]
      };
  },
  computed: {
    srcSet: ({ imgproxySrc: e, src: r, widths: i, background: s }) => i.map(
      (n) => e(r, { width: n, background: s, useSrcSet: !0 })
    )
  },
  methods: {
    imgproxySrc(e, { width: r, ...i }) {
      const { format: s } = this;
      let { quality: n } = this;
      const l = `.${s.replace("jpeg", "jpg")}`;
      n = n || this.$config.imgproxyDefaultQuality || $;
      const u = [
        "resize:fit",
        `width:${r}`,
        `quality:${n}`
      ];
      i.background && (i.background.trim() === "" ? console.warn("options.background must be a non-empty string") : u.push(`background:${i.background}`)), g.useBaseUrl(this.$config.imageProxyUrl);
      const d = g.transform(e, u.join("/")) + l;
      return i.useSrcSet ? `${d} ${r}w` : d;
    },
    imageLoaded(e) {
      this.$emit("imageLoaded", e);
    }
  }
}, _ = {};
var k = /* @__PURE__ */ S(
  b,
  y,
  v,
  !1,
  C,
  null,
  null,
  null
);
function C(e) {
  for (let r in _)
    this[r] = _[r];
}
const w = /* @__PURE__ */ function() {
  return k.exports;
}();
export {
  w as default
};
//# sourceMappingURL=vue2-image.js.map
